"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _index = _interopRequireDefault(require("./rmissues/index.js"));

var _index2 = _interopRequireDefault(require("./raisenewproblem/index.js"));

var _index3 = _interopRequireDefault(require("./pastproblems/index.js"));

var helpandsupport = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(helpandsupport, _Component);

  var _super = (0, _createSuper2.default)(helpandsupport);

  function helpandsupport() {
    (0, _classCallCheck2.default)(this, helpandsupport);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(helpandsupport, [{
    key: "render",
    value: function render() {
      var match = this.props.match;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/rmProblem"),
        component: _index.default
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/raiseProblem"),
        component: _index2.default
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/pastproblem"),
        component: _index3.default
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        from: "".concat(match.url),
        to: "".concat(match.url, "/raiseProblem")
      })));
    }
  }]);
  return helpandsupport;
}(_react.Component);

var _default = helpandsupport;
exports.default = _default;